import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { minorScale, Pane, Icon, Heading, Tooltip } from 'evergreen-v4'

const getTooltipForType = type => {
  switch (type) {
    case 'success':
      return 'This event has been received in the last 24 hours, making it a strong event for your audience.'
    case 'danger':
      return 'This event has not been active in the past 30 days, making it a weak event for your audience.'
    case 'warning':
      return 'This event has been received in the past 30 days, making it a good event for your audience.'
    default:
      return ''
  }
}

const getColorForType = type => {
  switch (type) {
    case 'success':
      return 'success'
    case 'danger':
      return 'danger'
    case 'warning':
      return 'warning'
    default:
      return 'info'
  }
}

export default class Group extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    style: PropTypes.any,
    height: PropTypes.number,
    status: PropTypes.oneOf(['success', 'warning', 'danger']),
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func
  }

  render() {
    const { label, style, height, status, isOpen, onToggle } = this.props

    return (
      <Pane
        style={style}
        height={height}
        background="tint1"
        display="flex"
        alignItems="center"
        borderBottom="muted"
        cursor="pointer"
        onClick={onToggle}
      >
        <Pane flex="1" display="flex" alignItems="center">
          <Icon
            icon={isOpen ? 'caret-up' : 'caret-down'}
            marginX={minorScale(3)}
            size={12}
          />

          <Heading size={100} fontWeight={500} color="muted">
            {label}
          </Heading>
        </Pane>

        <Tooltip content={getTooltipForType(status)}>
          <Icon
            icon="full-circle"
            size={6}
            color={getColorForType(status)}
            opacity={0.8}
            marginRight={8}
          />
        </Tooltip>
      </Pane>
    )
  }
}
